import { h } from 'preact';
import Button, { ButtonProps } from '@ingka/button';
import { PREFIX } from 'DesignSystem/constants';
import './button.scss';

export default (props: ButtonProps) => <Button prefix={PREFIX} {...props} />;
